import { ICondition } from '../../interfaces';
import { Observable } from 'rxjs';
import { NotificationService } from '../../services';
import { ConditionFailReason } from '../../models/condition-fail-reason.model';
import { ConditionFailEvent } from '../../models/condition-fail-event.model';

export abstract class BaseCondition implements ICondition {
  observable: Observable<boolean>;
  notificationService: NotificationService;
  conditionName: string;
  constructor(name: string, notificationService: NotificationService) {
    this.conditionName = name;
    this.notificationService = notificationService;
  }
  onConditionFail(error: ConditionFailReason, errorMessage: string): void {
    console.log(errorMessage);
    if (this.notificationService) {
      let conditionFailEvent = new ConditionFailEvent(this.conditionName, ConditionFailReason[error], errorMessage);
      this.notificationService.sendConditionFailEvent(conditionFailEvent);
    }
  }
}
